import { httpDelete, httpGet, httpPatch, httpPost } from "../connection";

export async function getRecentCases(params = {}) {
  return await httpGet(`/cases/recent`, params);
}

export async function addRecentCase(values = {}) {
  return await httpPost(`/cases/recent`, values);
}
